export default function getCookie(cname, doDecodeURI, noUrlAppend){
    
    // 依網址判斷附加後綴
    let urlAppend = ''
    if(window.location.href.indexOf('localhost') !== -1){
        urlAppend = ''
    }else if(window.location.href.indexOf('tmycrm') !== -1){
        urlAppend = '.T'
    }else if(window.location.href.indexOf('smycrm') !== -1){
        urlAppend = '.S' 
    }
    
    var name = cname + (noUrlAppend===true ? "" : urlAppend) + "=";
    var decodedCookie = doDecodeURI===false ? document.cookie : decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(';');
    for(var i = 0; i <ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') {
        c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
        }
    }
    return "";
}